import { RuleId } from '@wix/a11y-rules';
export let PageCompletionStatus = /*#__PURE__*/function (PageCompletionStatus) {
  PageCompletionStatus["ManualCompleted"] = "manualCompleted";
  PageCompletionStatus["AutomaticCompleted"] = "automaticCompleted";
  return PageCompletionStatus;
}({});
//# sourceMappingURL=rule-state-mapper.js.map